<app-page-title [title]="pageLabel()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="pageLabel()" (retry)="init()"></app-page-loader>

<!-- Indicadores del rango visible: filtran por tipo -->
<app-kpi-strip [kpis]="kpis" [active]="activeKpi" (activeChange)="setKpi($event)"></app-kpi-strip>

<div class="agenda">
  <!-- Controles -->
  <div class="filter-bar filter-bar--flush">
    <div class="filter-card">
      <div class="nav">
        <button mat-icon-button (click)="goToPrevious()" matTooltip="Anterior"><mat-icon>chevron_left</mat-icon></button>
        <button mat-stroked-button class="nav__today" (click)="goToToday()">Hoy</button>
        <button mat-icon-button (click)="goToNext()" matTooltip="Siguiente"><mat-icon>chevron_right</mat-icon></button>
      </div>
      <h3 class="agenda__title">{{ getCalendarTitle() }}</h3>
      <app-search-pill [value]="searchText" placeholder="Folio, hospital, paciente, DLV…" (valueChange)="setSearch($event)"></app-search-pill>
      <mat-button-toggle-group class="view-toggle" [value]="currentView" (change)="changeView($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
        <mat-button-toggle value="month">Mes</mat-button-toggle>
        <mat-button-toggle value="week">Semana</mat-button-toggle>
        <mat-button-toggle value="day">Día</mat-button-toggle>
      </mat-button-toggle-group>
      <button mat-icon-button (click)="refresh()" [disabled]="loading" matTooltip="Actualizar"><mat-icon>refresh</mat-icon></button>
    </div>
  </div>

  <!-- Leyenda -->
  <div class="legend">
    @for (k of kinds; track k.kind) {
      <button type="button" class="legend__item" [class.legend__item--off]="activeKpi && activeKpi !== k.kind"
              (click)="setKpi(activeKpi === k.kind ? null : k.kind)" [style.--kind]="k.color">
        <mat-icon>{{ k.icon }}</mat-icon>{{ k.label }}
      </button>
    }
    @if (loading) { <mat-spinner diameter="18"></mat-spinner> }
  </div>

  <!-- Mes -->
  @if (currentView === 'month') {
    <div class="month">
      @for (d of weekDays; track d) { <div class="month__wd">{{ d }}</div> }
      @for (day of calendarDays; track day.date.getTime()) {
        <div class="month__day" [class.month__day--other]="!day.isCurrentMonth" [class.month__day--today]="day.isToday"
             [class.month__day--has]="day.events.length" (click)="onDayClick(day)">
          <div class="month__num">{{ day.day }}</div>
          <div class="month__events">
            @for (ev of day.events.slice(0, 3); track ev.kind + ev.id) {
              <div class="chip-ev" [style.--kind]="kindMeta[ev.kind].color" (click)="$event.stopPropagation(); openEvent(ev)" [matTooltip]="kindMeta[ev.kind].singular + ' · ' + ev.title + (ev.place ? ' · ' + ev.place : '')">
                <mat-icon>{{ kindMeta[ev.kind].icon }}</mat-icon><span>{{ ev.hasTime ? (ev.date | date:'HH:mm') + ' ' : '' }}{{ ev.title }}</span>
              </div>
            }
            @if (day.events.length > 3) {
              <div class="month__more">
                @for (k of kindCounts(day.events); track k.kind) {
                  <span class="count" [style.--kind]="k.color" [matTooltip]="k.label"><mat-icon>{{ k.icon }}</mat-icon>{{ k.count }}</span>
                }
                <span class="month__more-link">+{{ day.events.length - 3 }} más</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- Semana -->
  @if (currentView === 'week') {
    <div class="week">
      @for (day of calendarDays; track day.date.getTime()) {
        <div class="week__day" [class.week__day--today]="day.isToday">
          <button type="button" class="week__head" (click)="onDayClick(day)">
            <span>{{ weekDays[day.date.getDay()] }}</span><b>{{ day.day }}</b>
            @if (day.events.length) { <small>{{ day.events.length }}</small> }
          </button>
          <div class="week__events">
            @for (ev of day.events; track ev.kind + ev.id) {
              <div class="ev-card" [style.--kind]="kindMeta[ev.kind].color" (click)="openEvent(ev)">
                <div class="ev-card__top"><mat-icon>{{ kindMeta[ev.kind].icon }}</mat-icon>@if (ev.hasTime) {<span>{{ ev.date | date:'HH:mm' }}</span>}</div>
                <b>{{ ev.title }}</b>
                @if (ev.place) { <small>{{ ev.place }}</small> }
                @if (ev.status) { <span class="ev-status">{{ ev.status }}</span> }
              </div>
            } @empty {
              <div class="empty">Sin eventos</div>
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- Día -->
  @if (currentView === 'day') {
    <div class="day">
      @for (ev of calendarDays[0]?.events ?? []; track ev.kind + ev.id) {
        <div class="day__item" [style.--kind]="kindMeta[ev.kind].color" (click)="openEvent(ev)">
          <div class="day__time">{{ ev.hasTime ? (ev.date | date:'HH:mm') : 'Todo el día' }}</div>
          <span class="day__icon"><mat-icon>{{ kindMeta[ev.kind].icon }}</mat-icon></span>
          <div class="day__body">
            <div class="day__top"><small>{{ kindMeta[ev.kind].singular }}</small><b>{{ ev.title }}</b></div>
            <div class="day__sub">{{ subLine(ev) }}</div>
          </div>
          @if (ev.status) { <span class="ev-status">{{ ev.status }}</span> }
          <mat-icon class="day__go">chevron_right</mat-icon>
        </div>
      } @empty {
        <div class="no-data panel"><mat-icon>event_available</mat-icon><span>No hay eventos este día con los filtros elegidos</span></div>
      }
    </div>
  }
</div>
